import Fuse from 'fuse.js';

export default {
	data() {
		return {
			changeView: 0,
			search: '',
			pagination: {
				rowsPerPage: 24,
				sortBy: 'id',
				descending: true,
				page: 1,
			},
			sortBy: [
				{ name: 'Date Added', value: 'id' },
			],
			fuseOptions: {
				keys: ['name'],
				minMatchCharLength: 2,
				threshold: 0.4,
				shouldSort: true,
			},
			fuse: null,
			cardStyle: 'cardStyle',
			sortStorage: null,
		};
	},
	computed: {
		sortName() {
			const currentSort = this.sortBy.find(item => item.value === this.pagination.sortBy);
			if (!currentSort || !currentSort.name) {
				return 'Name';
			}
			return currentSort.name;
		},
		rowsPerPageItems() {
			const all = {
				text: 'All',
				value: -1,
			};

			if (this.items.length <= 24) {
				return [all];
			}
			if (this.items.length <= 48) {
				return [24, all];
			}
			if (this.items.length <= 96) {
				return [24, 48, all];
			}
			return [24, 48, 96, all];
		},
	},
	watch: {
		changeView() {
			localStorage.setItem(this.cardStyle, JSON.stringify(this.changeView));
		},
		items() {
			this.fuse = new Fuse(this.items, this.fuseOptions);
			// If last item of page# > 1 is deleted, this will make the page go back one instead
			// of remaining on an empty screen.
			const minItems = (this.pagination.page * this.pagination.rowsPerPage)
				- this.pagination.rowsPerPage;
			if (this.items.length <= minItems) {
				if (this.pagination.page === 1) {
					return;
				}
				this.pagination.page--;
			}
		},
		'pagination.page': {
			handler() {
				// Nav bar covers part of iterator when using scroll into view without toolbar
				if (this.hideToolbar) {
					window.scrollTo(0, 600);
					return;
				}
				this.$refs.iterator.$el.scrollIntoView();
			},
		},
	},
	created() {
		this.fuse = new Fuse(this.items, this.fuseOptions);
		this.changeView = JSON.parse(localStorage.getItem(this.cardStyle)) || 0;
		this.setPaginationFromSortStorage();
	},
	methods: {
		setPaginationFromSortStorage() {
			if (!this.sortStorage) {
				return;
			}
			const sortStorage = JSON.parse(localStorage.getItem(this.sortStorage)) || null;
			if (!sortStorage) {
				return;
			}
			if (typeof sortStorage.descending === 'boolean') {
				this.pagination.descending = sortStorage.descending;
			}
			const sortVals = this.sortBy.map(val => val.value);
			if (sortVals.includes(sortStorage.sortBy)) {
				this.pagination.sortBy = sortStorage.sortBy;
			}
		},
		sort(option) {
			this.pagination.sortBy = option.value;
			this.setSortStorage();
		},
		setSortStorage() {
			if (!this.sortStorage) {
				return;
			}
			localStorage.setItem(this.sortStorage, JSON.stringify(this.pagination));
		},
		changeSortDirection() {
			this.pagination.descending = !this.pagination.descending;
			this.setSortStorage();
		},
		filterItems(items, search, filter) {
			if (search === '') {
				return items;
			}
			const results = this.fuse.search(search);
			return results;
			// const searchQuery = search.toString().toLowerCase();
			// return items.filter(projects => filter(projects.name, searchQuery));
		},
		customSort(items, index, isDescending) {
			if (index === null) return items;
			if (this.search !== '') {
				return items;
			}
			const sortedItems = items.sort((a, b) => {
				let sortA = a[index];
				let sortB = b[index];

				if (isDescending) {
					[sortA, sortB] = [sortB, sortA];
				}

				// Check if both are numbers
				// eslint-disable-next-line
				if (!isNaN(sortA) && !isNaN(sortB)) {
					return sortA - sortB;
				}

				// Check if both cannot be evaluated
				if (sortA === null && sortB === null) {
					return 0;
				}

				[sortA, sortB] = [sortA, sortB]
					.map(s => (
						(s || '').toString().toLocaleLowerCase()
					));

				if (sortA > sortB) return 1;
				if (sortA < sortB) return -1;

				return 0;
			});

			// Set default as first
			sortedItems.sort((a, b) => b.default - a.default);

			return sortedItems;
		},
	},
};
